import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import { passwordChecks } from '../utils/validation';

// Живий перелік вимог до паролю під полем вводу.
// Кожна вимога зеленіє, щойно виконана. Порожній пароль -> усі нейтральні.
export default function PasswordRequirements({ value, sx }) {
  const { t } = useTranslation();
  const checks = passwordChecks(value);
  return (
    <Box sx={{ mt: 0.5, ...sx }}>
      {checks.map((c) => {
        const active = !!value && c.ok;
        const color = active ? 'success.main' : 'text.secondary';
        const Icon = active ? CheckCircleIcon : RadioButtonUncheckedIcon;
        return (
          <Box key={c.key} sx={{ display: 'flex', alignItems: 'center', gap: 0.75, color }}>
            <Icon sx={{ fontSize: 16 }} />
            <Typography variant="caption" sx={{ color }}>{t(c.key)}</Typography>
          </Box>
        );
      })}
    </Box>
  );
}
